import { useMemo } from 'react';
import { useConversationMessages, useIsTextConversation } from '@/entities/conversations';
import { toMessageMarkSentAt } from '../lib/commentMessageMarks';

/**
 * Цели меток места в переписке для {@link MessageMarkTargetsContext}: у текстовой коммуникации —
 * первый элемент переписки каждой минуты отправки, у прочих диалогов — null.
 *
 * Переписка — та же, что в ленте: запрос общий, повторно не уходит. Пока она грузится, целей нет,
 * и метки показываются текстом.
 */
export const useMessageMarkTargets = (conversationId: number): ReadonlyMap<string, number> | null => {
  const isText = useIsTextConversation(conversationId);
  const { data: messages } = useConversationMessages(conversationId, isText);

  return useMemo(() => {
    if (!isText) return null;
    const targets = new Map<string, number>();
    for (const message of messages ?? []) {
      const sentAt = toMessageMarkSentAt(message.createdAt);
      // Порядок ответа — порядок переписки: в минуту нескольких элементов метка ведёт к первому
      if (sentAt !== undefined && !targets.has(sentAt)) targets.set(sentAt, message.id);
    }
    return targets;
  }, [isText, messages]);
};
